import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../../+app-custom/services/authentication.service';
import {Router} from '@angular/router';
import {UserService} from '../../../+app-custom/services/user.service';
import {AppCommunicationService} from '../../../+app-custom/services/app-communication.service';
import {NotificationService} from '../../utils/notification.service';
import { AppRedirectService } from '../../../+app-custom/services/app-redirect.service';

@Component({
    selector: 'app-sa-login-info',
    templateUrl: './login-info.component.html',
    styleUrls: ['./login-info.component.css']
})
export class LoginInfoComponent implements OnInit {
    name: string;
    surname: string;
    isExternal: boolean;

    employments = [];
    activeEmployment = '0';

    constructor(
        private userService: UserService,
        private authService: AuthenticationService,
        private router: Router,
        private notificationService: NotificationService,
        private appRedirectService: AppRedirectService
    ) {
    }

    profileRedirect() {
        this.router.navigate(['/profile']);
    }

    logout() {
        this.authService.logout().subscribe(
                () => {
                },
                (error2) => {
                    console.log(error2);
                }
            )
    }

    ngOnInit() {
        this.getLoggedUser();
        this.getEmployments();
        this.checkActiveEmployment();
    }

    getLoggedUser() {
        this.name = AppCommunicationService.getCurrentUser().user.name;
        this.surname = AppCommunicationService.getCurrentUser().user.surname;
        this.isExternal = AppCommunicationService.getCurrentUser().user.isExternal;
    }

    getEmployments() {
        this.authService.getEmployments()
            .subscribe(value => {
                this.employments = value;
            })
    }

    changeEmployment(employmentCode) {
        this.authService.changeEmployment(employmentCode)
            .subscribe(
                () => {
                    this.checkActiveEmployment();
                    location.reload();
                    this.successMessage();
                },
                () => this.errorMessage()
            )
    }

    checkActiveEmployment() {
        this.activeEmployment = AppCommunicationService.getCurrentUser().user.employmentCode;
    }

    /* ##### Alert messages ##### */
    successMessage() {
        this.notificationService.smallBox({
            title: 'Zmena pracoviska',
            content: 'Zmena pracoviska prebehla úspešne.',
            color: '#296191',
            timeout: 3000
        });
    }

    errorMessage() {
        this.notificationService.smallBox({
            title: 'Chyba',
            content: 'Vyskytla sa chyba počas zmeny pracoviska. Za vzniknuté problémy sa ospravedlňujeme.',
            color: '#aa3333',
            timeout: 5000
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/user/login-info/login-info.component.ts